// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
// import orbitcontrols from 'three-orbitcontrols'

import iView from "view-design";
import "view-design/dist/styles/iview.css";
import "./assets/css/style.css";
import store from "./vuex/store";
import VueClipboard from "vue-clipboard2";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import Axios from "axios";
import OnlyMessage from "./assets/js/message";
import VueBarcode from "vue-barcode";
import moment from "moment";
import qs from "qs";

import echarts from "echarts";
import "./assets/slider_font/iconfont.css";
import "./assets/content_font/iconfont.css";
/**
 * 使用地图
 */
import china from "echarts/map/json/china.json";
echarts.registerMap("china", china);

// 可编辑table
import "xe-utils";
import VXETable from "vxe-table";
import "vxe-table/lib/index.css";

// 引用API文件
import api from "./api/api";
// 引入 public 库
import * as globalFun from "../src/assets/js/common";
// 打印
import Print from "vue-print-nb";

import Viewer from "v-viewer";
import "viewerjs/dist/viewer.css";

//Vue.use(Viewer) 默认配置写法
//Vue.use(Viewer) 默认配置写法
Vue.use(Viewer, {
  defaultOptions: {
    zIndex: 9999,
  },
});

// 可编辑table
Vue.use(ElementUI);
Vue.use(VXETable);

Vue.use(Print);

// 将API方法绑定到全局
Vue.prototype.$moment = moment;
Vue.prototype.$api = api;
Vue.prototype.$qs = qs;
Vue.prototype.$http_axios = Axios;
Vue.prototype.$echarts = echarts;
Vue.prototype.$globalFun = globalFun;
Vue.prototype.$message = OnlyMessage;
Vue.component("barcode", VueBarcode);

// Vue.prototype.orbitcontrols = orbitcontrols
Vue.config.productionTip = false;
Vue.use(VueClipboard);
Vue.use(iView);
// eslint-disable-next-line no-new

Vue.directive("preventReClick", {
  inserted: function(el, binding) {
    el.addEventListener("click", () => {
      if (!el.disabled) {
        el.disabled = true;
        setTimeout(() => {
          el.disabled = false;
        }, binding.value || 3000);
      }
    });
  },
});
// 除登录页面外任意页面未登录情况下跳回登录页面
router.beforeEach(function(to, from, next) {
  if (localStorage.getItem("userInfo") || to.name === "login" || to.name === "scanCode") {
    next();
  } else {
    next({ path: "/" });
  }
});

new Vue({
  el: "#app",
  router,
  store,
  render: h => h(App),
});

function init() {
  let screenRatioByDesign = 16 / 9;
  let docEle = document.documentElement;
  function setHtmlFontSize() {
    var screenRatio = docEle.clientWidth / docEle.clientHeight;
    var fontSize =
      ((screenRatio > screenRatioByDesign ? screenRatioByDesign / screenRatio : 1) *
        docEle.clientWidth) /
      10;
    docEle.style.fontSize = fontSize.toFixed(3) + "px";
  }
  setHtmlFontSize();
  window.addEventListener("resize", setHtmlFontSize);
}
init();



// WEBPACK FOOTER //
// ./src/main.js